import Main from './Main';
import Navigation from './Navigation';
import NavigationMui from './NavigationMui';
import React from 'react';
import './App.css';
import logo from './logo.png';
import { Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css'; // Import default styles
import awsconfig from './aws-exports'; // Import your AWS Amplify configuration
Amplify.configure(awsconfig);


function App({ signOut, user }) {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
            width: '100%',
            maxWidth: '1200px', // Optional max width
            marginBottom: '20px',
          }}
        >
          <a href="/">
            <img
              src={logo}
              alt="Logo"
              style={{ height: '70px', width: '150px', margin: '25px' }}
            />
          </a>

          <div style={{ margin: '25px' }}>
            <h1 style={{ color: '#be1f41', margin: '25px' }}>
              Dispensary of Hope Internal Portal
            </h1>
          </div>

          <button
            style={{
              width: '13%',
              height: '3rem',
              backgroundColor: '#be1f41',
              margin: '10px',
              minWidth: '70px',
              border: 'none',
              color: 'white',
              fontSize: '15px',
              fontWeight: 'bold',
              paddingLeft: '30px',
              paddingRight: '30px',
              borderRadius: '20px',
            }}
            onClick={signOut}
          >
            Sign out
          </button>
        </div>
        <div>
          <NavigationMui/>
        </div>
      </div>
      
      <Main/>
      
      
      

    </>
  );
}

export default withAuthenticator(App);
